import { createReducer, on } from "@ngrx/store";
import { DateProviderState, initialDateProviderState } from "./date-provider.state";
import { GetDateProvider, GetDateProviderError, GetDateProviderSuccess } from "./date-provider.actions";

export const DateProviderReducer = createReducer(
    initialDateProviderState,
    on(GetDateProvider, (state): DateProviderState => {
        return {
            ...state,
            loading: true,
            dateProvider: null,
            error: null
        };
    }),
    on(GetDateProviderSuccess, (state, action): DateProviderState => {
        return {
            ...state,
            loading: false,
            dateProvider: action.dateProvider,
            error: null
        }
    }),
    on(GetDateProviderError, (state, action): DateProviderState => {
        return {
            ...state,
            loading: false,
            error: action.error,
            dateProvider: null
        }
    })
);